import React, { useEffect } from 'react';

import { FLink } from '@components';
import { useDispatch, useSelector } from 'react-redux';
import { currency } from '@utils';
import {
  EMPRESTIMO_CONSCIENTE,
  TIRA_DUVIDAS,
  REGULAMENTO_EMPRESTIMO,
  SIMULADOR_ABSOLUTE_PATH,
} from '../../../utils/paths';
import { getLimite } from '../../../../store/loan/thunks';

export const EmprestimosCard = () => {
  const dispatch = useDispatch();
  const { simular_emprestimo: showSimular } = useSelector(
    (state) => state.configs.telasDisponiveis.data
  );
  const {
    total: limite,
    requestDone: limiteRequestDone,
    loading: limiteLoading,
  } = useSelector((state) => state.loan.limite);
  const { matricula, token } = useSelector((state) => state.user.data);

  useEffect(() => {
    if (!showSimular) {
      return;
    }

    if (!matricula || !token) {
      return;
    }

    if (limiteRequestDone || limiteLoading) {
      return;
    }

    dispatch(getLimite());
  }, [
    dispatch,
    showSimular,
    limiteRequestDone,
    limiteLoading,
    matricula,
    token,
  ]);

  return (
    <div className="card">
      <div className="card-body">
        <h1 className="ts-20 fw-bold mb-2">Empréstimos</h1>
        <p className="ts-14 text-muted mb-2">
          Antes de contratar um empréstimo analise os itens abaixo.
        </p>
        <hr className="mb-3" />
        <FLink icon to={EMPRESTIMO_CONSCIENTE}>
          Saiba mais sobre crédito consciente
        </FLink>
        <hr className="my-3" />
        <FLink icon to={TIRA_DUVIDAS}>
          Tire suas dúvidas
        </FLink>
        <hr className="my-3" />
        <FLink icon to={REGULAMENTO_EMPRESTIMO}>
          Leia o regulamento
        </FLink>
        <hr className="my-3" />
        {showSimular && (
          <FLink icon to={SIMULADOR_ABSOLUTE_PATH}>
            Simulação de empréstimo
          </FLink>
        )}

        {showSimular && !!limite && (
          <div>
            <hr className="my-3 mt-32" />
            <p className="ts-14 text-muted">
              Seu limite pré-aprovado na data de hoje:{' '}
              {currency(Math.floor(limite))}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
